import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.scss';
import LogoYellow from '../Icons/LogoYellow';

const Footer = () => {
  // Get the current year
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.footer}>
      <div className={styles.footerHead}>
        <LogoYellow />
      </div>
      <div className={styles.footerChunk}>
        <div className={styles.footerBody}>
          <div className={styles.footerColumn}>
            <p className={styles.footerText}>
              Good Song Club was conceived, designed, and built by{' '}
              <Link
                to={`/user/mBTU1WC0d0WKE7e1gbe1kYMiwqO2`}
                className={styles.userLink}
              >
                Roby Saavedra
              </Link>{' '}
              in beautiful Oakland, CA.
            </p>
          </div>
          <div className={styles.footerColumn}></div>
          <div className={styles.footerColumn}>
            <p className={styles.footerText}>
              <a href="/tos" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>
            </p>
            <p className={styles.footerText}>
              <a href="/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <span className={styles.footerBottomLeft}>
            <a href="mailto:hello@goodsong.club">hello@goodsong.club</a>
            <a
              href="https://bsky.app/profile/goodsongclub.bsky.social"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="Bluesky"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6.90172 6.00967C8.96538 7.476 11.185 10.4492 12 12.0445C12.815 10.4492 15.0346 7.476 17.0983 6.00967C18.5873 4.95166 21 4.13301 21 6.73798C21 7.25822 20.6848 11.1083 20.5 11.7335C19.8575 13.9065 17.5162 14.4608 15.4335 14.1253C19.0739 14.7117 20 16.6541 18 18.5964C14.2016 22.2853 12.5407 17.6709 12.1151 16.4885C12.037 16.2717 12.0005 16.1703 12 16.2565C11.9995 16.1703 11.963 16.2717 11.8849 16.4885C11.4593 17.6709 9.79839 22.2853 6 18.5964C4 16.6541 4.92606 14.7117 8.56647 14.1253C6.48379 14.4608 4.14254 13.9065 3.5 11.7335C3.31517 11.1083 3 7.25822 3 6.73798C3 4.13301 5.41271 4.95166 6.90172 6.00967Z" fill="#F6D566"/>
              </svg>
            </a>
            <a
              href="https://x.com/goodsongclub"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="X"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20.131 19.8478L14.2623 10.6247L20.0532 4.25438C20.1842 4.10674 20.2517 3.91343 20.2411 3.71636C20.2305 3.51929 20.1427 3.33435 19.9966 3.20161C19.8505 3.06888 19.6581 2.99907 19.4609 3.00731C19.2637 3.01555 19.0777 3.10117 18.9432 3.24562L13.427 9.31312L9.63105 3.34781C9.56336 3.24127 9.46988 3.15353 9.35926 3.09274C9.24864 3.03194 9.12446 3.00004 8.99824 3H4.49824C4.36376 2.99993 4.23174 3.03603 4.116 3.10449C4.00027 3.17296 3.90507 3.27129 3.84037 3.38918C3.77568 3.50707 3.74387 3.64018 3.74827 3.77458C3.75268 3.90898 3.79314 4.03973 3.86542 4.15313L9.73417 13.3753L3.94324 19.7503C3.87561 19.823 3.82308 19.9083 3.78868 20.0014C3.75428 20.0945 3.7387 20.1935 3.74284 20.2927C3.74698 20.3918 3.77077 20.4892 3.81281 20.5791C3.85486 20.669 3.91433 20.7496 3.98778 20.8164C4.06123 20.8831 4.14719 20.9346 4.24069 20.9679C4.3342 21.0012 4.43337 21.0156 4.53248 21.0103C4.63158 21.0049 4.72864 20.98 4.81804 20.9369C4.90743 20.8937 4.98737 20.8333 5.05324 20.7591L10.5695 14.6916L14.3654 20.6569C14.4337 20.7625 14.5274 20.8494 14.638 20.9093C14.7486 20.9693 14.8724 21.0005 14.9982 21H19.4982C19.6326 21 19.7644 20.9638 19.88 20.8954C19.9956 20.827 20.0907 20.7288 20.1554 20.611C20.22 20.4933 20.2519 20.3604 20.2476 20.2261C20.2433 20.0918 20.2031 19.9612 20.131 19.8478ZM15.4098 19.5L5.86417 4.5H8.58292L18.1323 19.5H15.4098Z" fill="#F6D566"/>
              </svg>
            </a>
          </span>
          <span className={styles.footerBottomRight}>
            Good Song Club &copy; {currentYear}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
